'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var SelectButtonFieldContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])));
var SelectButtonWrapper = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n\n  .select-button-label {\n    margin-right: 16px;\n  }\n"], ["\n  display: flex;\n\n  .select-button-label {\n    margin-right: 16px;\n  }\n"])));
var templateObject_1, templateObject_2;

exports.SelectButtonFieldContainer = SelectButtonFieldContainer;
exports.SelectButtonWrapper = SelectButtonWrapper;
